
import moment from 'moment'
import 'moment/locale/es'

export const HeaderLogoRight = ({ infoEmp, infoGeneral, dataPreview }) => {

    const { pdf_color_formato, ppto_pdf_nombre_ppto, ppto_pdf_folio_con_fecha = false } = infoGeneral
    const { url_foto } = infoEmp

    return (
        <div className='header-pdf'>
            <div className='container-folio left'>
                {pdf_color_formato ?
                    <h1 style={{ color: pdf_color_formato }}>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </h1>
                    :
                    <h1 className='default-title'>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </h1>
                }

                {ppto_pdf_folio_con_fecha ?
                    <p className='info-folio'>{`N° ${moment(dataPreview.fecha_asignacion).format('YYYY')}-${dataPreview.numero}`}</p>
                    :
                    <p className='info-folio'>{`N° ${dataPreview.folio}`}</p>
                }

                <p className='sub-title fecha'>{moment(new Date()).format('DD MMMM YYYY')}</p>

                {(!dataPreview?.nro_version_actual > 0) &&
                    <p className='sub-title version'>Versión {dataPreview?.nro_version_actual || 1}</p>
                }

            </div>
            <div className='container-logo'>
                <img
                    src={url_foto}
                    alt="Logo empresa"
                />
            </div>
        </div>
    )
}